// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"c49c1652","977":"ebf8edad"}[chunkId] + ".chunk.js";
};